/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{signal as t}from"@lexical/extension/signals";function e(e,i){let n;return t(e(),{unwatched(){n&&(n(),n=void 0)},watched(){this.value=e(),n=i(this)}})}export{e as watchedSignal};
